export const saveTrackingData = data => (dispatch) => {
  dispatch({ type: 'SAVE_TRACKING_DATA', payload: data });
};

export default saveTrackingData;
